exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.msg[data-v-19e7589a] {\n  margin-bottom: 70px;\n}\n.msg h4[data-v-19e7589a] {\n  color: #449d7a;\n}\n", ""]);

// exports
